import React, { useState } from "react";
import "./Services.css";
import '@fortawesome/fontawesome-free/css/all.css';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const [selectedOption, setSelectedOption] = useState("birthcert");
  const [cnic, setCnic] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [error, setError] = useState("");
  const [records, setRecords] = useState([]);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (selectedOption !== "fir" && !cnic) {
      setError("Please enter CNIC");
      return;
    }
    if (selectedOption === "fir" && !phoneNo) {
      setError("Please enter Phone Number");
      return;
    }
    try {
      const response = await fetch("https://chaman.gov.pk/eac_backend/search.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "get_records_by_cnic",
          cnic: selectedOption !== "fir" ? cnic : null,
          phone_no: selectedOption === "fir" ? phoneNo : null,
          table: selectedOption.replace(" ", "").toLowerCase(),
        }),
      });
      const data = await response.json();
      if (data.status === "success" && data.data) {
        setRecords(data.data);
        setError("");
      } else {
        setError("No records found");
        setRecords([]);
      }
    } catch (err) {
      setError("Error fetching data");
      setRecords([]);
    }
  };

  const handleOptionChange = (e) => {
    const newOption = e.target.value;
    setSelectedOption(newOption);
    setRecords([]);
    setError("");
    setCnic("");
    setPhoneNo("");
  };

  return (
    <div className="search-wrapper">
      <div className="left-section">
        <h4 className="section-title">Search Application</h4>
        <select id="recordType" value={selectedOption} onChange={handleOptionChange}>
          <option value="birthcert">Birth Certificate</option>
          <option value="deathcert">Death Certificate</option>
          <option value="marriagecert">Marriage Certificate</option>
          <option value="localcert">Local Certificate</option>
          <option value="localdom">Local Domicile</option>
          <option value="passport">Passport Application</option>
          <option value="arms">Arms License</option>
          <option value="fir">FIR</option>
          <option value="complaints">Complaints</option>
        </select>
        <div className="input-row">
          {selectedOption !== "fir" ? (
            <input
              id="s1"
              type="text"
              value={cnic}
              onChange={(e) => setCnic(e.target.value)}
              placeholder="Enter CNIC"
            />
          ) : (
            <input
              id="s2"
              type="text"
              value={phoneNo}
              onChange={(e) => setPhoneNo(e.target.value)}
              placeholder="Enter Phone Number"
            />
          )}
          <button id="sb" onClick={handleSearch}>
            <i className="fas fa-search"></i>
          </button>
        </div>
        {error && <p className="error">{error}</p>}
        <div className="main">
          {records.length > 0 ? (
            <div className="records-container">
              {records.map((record, i) => (
                <div key={i} className="record-item">
                  {selectedOption === "complaints" ? (
                    <>
                      <p>Name: {record.name}</p>
                      <p>CNIC: {record.cnic}</p>
                      <p>Complaint: {record.complaint}</p>
                      <p>Priority: {record.priority}</p>
                      <p>Feedback: {record.feedback}</p>
                      <p>Status: {record.status}</p>
                    </>
                  ) : selectedOption === "fir" ? (
                    <>
                      <p id="sp">FIR ID: {record.token_id}</p>
                      <p>Levies Station: {record.thana}</p>
                      <p>Phone Number: {record.phone_no}</p>
                      <p>Date of Report: {record.r_date}</p>
                      <p>Status: {record.status_f}</p>
                    </>
                  ) : (
                    <>
                      <p id="sp">Token ID: {record.token_id}</p>
                      <p>Name: {record.name}</p>
                      <p>Father Name: {record.father_name}</p>
                      <p>CNIC: {record.cnic}</p>
                      <p>Date: {record.date}</p>
                      <p>Status: {record.status}</p>
                    </>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p id="rec"></p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Services;
